import { ListItemButton, ListItemText } from '@mui/material';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/authSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LogoutButton = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
  
    const handleLogout = () => {
      dispatch(logout());
      navigate('/login');
    };

    return (
        <ListItemButton onClick={handleLogout}>
            <ListItemText primary={t('Logout')} /> 
        </ListItemButton>
    )
}

export default LogoutButton